import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// axiosInstance, non axios nudo: l'interceptor allega il Bearer token.
// Gli endpoint /v1/user sono @isAdmin, quindi senza token rispondono 403.
// baseURL e' gia' impostata sull'istanza, percio' i path qui sono relativi.
import axiosInstance from './services/axiosInstance';
import api from './services/api';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  const fetchUsers = async (selectedPage) => {
    try {
      const response = await axiosInstance.get('/v1/user/list', {
        params: {
          page: selectedPage,
          size: 10, // Numero di utenti per pagina
        },
      });
      setUsers(response.data.content);
      setPageCount(response.data.totalPages);
    } catch (error) {
      toast.error('Errore durante il recupero degli utenti');
    }
  };

  /* Invio massivo dei link di accesso.
   * Gira SEMPRE prima in simulazione: mostra chi verrebbe contattato senza
   * mandare nulla. L'invio reale richiede una conferma esplicita, perche'
   * scrive a destinatari veri. */
  const [simulazione, setSimulazione] = useState(null);
  const [invioInCorso, setInvioInCorso] = useState(false);

  const simulaInvioMassivo = async () => {
    setInvioInCorso(true);
    try {
      const { data } = await api.inviaAccessoMassivo('ROLE_AZIENDA', true);
      setSimulazione(data);
    } catch (e) {
      toast.error('Simulazione non riuscita');
    } finally {
      setInvioInCorso(false);
    }
  };

  const inviaDavvero = async () => {
    const quanti = simulazione?.destinatari?.length || 0;
    if (!window.confirm(`Inviare davvero il link di accesso a ${quanti} aziende?`)) return;
    setInvioInCorso(true);
    try {
      const { data } = await api.inviaAccessoMassivo('ROLE_AZIENDA', false);
      toast.success(`Inviati ${data.inviati} messaggi`);
      setSimulazione(null);
    } catch (e) {
      toast.error('Invio non riuscito');
    } finally {
      setInvioInCorso(false);
    }
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleToggleActive = async (userId, isActive) => {
    try {
      await axiosInstance.put(`/v1/user/${userId}/status`, { active: !isActive });
      fetchUsers(currentPage);
      toast.success('Utente ' + (!isActive ? 'attivato' : 'disattivato') + ' con successo');
    } catch (error) {
      toast.error('Errore durante la modifica dello stato utente');
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmDelete = window.confirm('Sei sicuro di voler cancellare questo utente?');
    if (confirmDelete) {
      try {
        await axiosInstance.delete(`/v1/user/${userId}`);
        setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
        toast.success('Utente cancellato con successo');
      } catch (error) {
        toast.error('Errore durante la cancellazione dell\'utente');
      }
    }
  };
  return (
    <div>
      <h2>Lista Utenti</h2>

      <section className="invio-massivo">
        <h3>Invio link di accesso alle aziende</h3>
        <p className="scheda-dati__nota">
          Serve per le aziende create prima che il link venisse inviato: non hanno
          una password utilizzabile e senza questo non possono entrare.
        </p>

        <div className="pannello-admin__riga">
          <button type="button" onClick={simulaInvioMassivo} disabled={invioInCorso}>
            Simula invio
          </button>
          {simulazione && (
            <button type="button" onClick={inviaDavvero} disabled={invioInCorso}>
              Invia davvero a {simulazione.destinatari?.length || 0} aziende
            </button>
          )}
        </div>

        {simulazione && (
          <div className="avviso avviso--successo">
            <strong>Simulazione — nessun messaggio inviato.</strong>
            <p style={{ margin: '6px 0' }}>
              Destinatari: {simulazione.destinatari?.length || 0}
            </p>
            {simulazione.saltati?.length > 0 && (
              <>
                <strong>Saltati:</strong>
                <ul className="avviso__elenco">
                  {simulazione.saltati.map((x, i) => <li key={i}>{x}</li>)}
                </ul>
              </>
            )}
          </div>
        )}
      </section>

      <table>
        <thead>
          <tr>
            <th>Titolare</th>
            <th>Nome azienda</th>
            <th>Email</th>
            <th>Tipo Azienda</th>
            <th>Tipo utente</th>
            <th>Attivo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.nome +' ' +  user.cognome}</td>
              <td>{user.nomeAzienda}</td>

              <td>{user.email}</td>
              <td>{user.tipologiaAzienda}</td>
              <td>{user.tipoUtente}</td>
              <td>
                <input
                  type="checkbox"
                  checked={user.active}
                  onChange={() => handleToggleActive(user.id, user.active)}
                />
              </td>
              <td>
              <div style={{ display: 'inline-block' }}>
    <Link to={`/user/${user.id}`}>Dettaglio</Link>      
  </div>
  <div style={{ display: 'inline-block', marginLeft: '10px' }}>
    <button onClick={() => handleDeleteUser(user.id)}>Cancella</button>
  </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={'Precedente'}
        nextLabel={'Successivo'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
      <ToastContainer />
    </div>
    
  );
};

export default UserList;
